module.exports = __webpack_public_path__ + "static/media/liabilities.39e9b85f.svg";